export default "/images/search-icon.svg?5ff75872b99979b63495dd85364a10aa";